import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	burndown: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.burndown',
		defaultMessage: 'Burndown Chart',
		description: 'Burndown Chart link item',
	},
	burnup: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.burnup',
		defaultMessage: 'Burnup Chart',
		description: 'Burnup Chart link item',
	},
	sprint: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.sprint',
		defaultMessage: 'Sprint Report',
		description: 'Sprint Report link item',
	},
	velocity: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.velocity',
		defaultMessage: 'Velocity Chart',
		description: 'Velocity Chart link item',
	},
	flow: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.flow',
		defaultMessage: 'Cumulative Flow Diagram',
		description: 'Cumulative Flow Diagram link item',
	},
	version: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.version',
		defaultMessage: 'Version Report',
		description: 'lVersion Report ink item',
	},
	epic: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.epic',
		defaultMessage: 'Epic Report',
		description: 'Epic Report link item',
	},
	control: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.control',
		defaultMessage: 'Control Chart',
		description: 'Control Chart link item',
	},
	epicBurndown: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.epic-burndown',
		defaultMessage: 'Epic Burndown',
		description: 'Epic Burndown link item',
	},
	releaseBurndown: {
		id: 'spa-apps-sidebar-user.controllers.reports.utils.release-burndown',
		defaultMessage: 'Release Burndown',
		description: 'Release Burndown link item',
	},
});
